export const INDUSTRIES = [
  {
    slug: "manufacturing",
    title: "GEO for Manufacturing",
    short: "Help buyers, distributors and procurement teams find you through AI research.",
    icon: "Factory",
    featured: true,
    keyword: "GEO for Manufacturing Companies",
    challenges: [
      "Technical products are hard for AI to describe accurately without structured data.",
      "Long, complex catalogues get flattened into generic answers.",
      "B2B buyers research suppliers via AI before ever contacting sales.",
    ],
    opportunities: [
      "Become the cited supplier when buyers ask AI for manufacturers in your category.",
      "Structure product specifications so AI quotes them precisely.",
      "Win export and distributor enquiries from AI-driven research.",
    ],
    strategy: [
      "Entity mapping for your company, plants, certifications and product lines.",
      "Product and specification schema for machine-readable accuracy.",
      "Answer-first content for common procurement questions.",
      "Authority building across trade and industry sources.",
    ],
    faqs: [
      { q: "Why does a manufacturer need GEO?", a: "Procurement teams increasingly shortlist suppliers using AI assistants. If AI cannot describe or recommend you accurately, you lose enquiries before a human sees your site." },
    ],
  },
  {
    slug: "real-estate",
    title: "GEO for Real Estate",
    short: "Be the developer, project or advisor AI recommends to buyers and investors.",
    icon: "Building2",
    featured: true,
    keyword: "GEO for Real Estate Developers",
    challenges: [
      "Buyers ask AI about locations, projects and developers before visiting.",
      "Inconsistent listing data confuses AI about your projects.",
      "Local intent is critical yet poorly structured for machines.",
    ],
    opportunities: [
      "Own AI answers for your city, micro-market and project categories.",
      "Structure project, location and amenity data for precise citation.",
      "Capture high-intent investor and buyer enquiries from AI research.",
    ],
    strategy: [
      "LocalBusiness and project entity optimization.",
      "Location and neighbourhood answer content.",
      "Consistent NAP and listing data across the web.",
      "Reputation and review signals for trust.",
    ],
    faqs: [
      { q: "How does GEO help real estate developers?", a: "It ensures AI accurately describes your projects and recommends you when buyers and investors research locations, developers and property types." },
    ],
  },
  {
    slug: "healthcare",
    title: "GEO for Healthcare",
    short: "Build the trust and accuracy AI requires to recommend healthcare providers.",
    icon: "HeartPulse",
    featured: true,
    keyword: "GEO for Healthcare Industry",
    challenges: [
      "Healthcare demands accuracy — AI misinformation is a real risk.",
      "Patients research symptoms, treatments and providers via AI.",
      "Trust and credentials must be verifiable by machines.",
    ],
    opportunities: [
      "Become the trusted, cited provider for your specialities and locations.",
      "Structure services, credentials and conditions for accurate answers.",
      "Correct and prevent inaccurate AI descriptions of your practice.",
    ],
    strategy: [
      "Medical entity and credential optimization.",
      "Condition and treatment answer content with E-E-A-T.",
      "MedicalOrganization and service schema.",
      "Authoritative citation and review building.",
    ],
    faqs: [
      { q: "Is GEO safe for regulated healthcare?", a: "Yes. We prioritise accuracy, verifiable credentials and compliant, evidence-based content — exactly the signals AI needs to trust and cite healthcare providers." },
    ],
  },
  { slug: "saas", title: "GEO for SaaS", short: "Get recommended when buyers ask AI for software in your category.", icon: "Cloud", keyword: "GEO for SaaS Companies" },
  { slug: "education", title: "GEO for Education", short: "Help students and parents discover your institution through AI.", icon: "GraduationCap", keyword: "GEO for Educational Institutions" },
  { slug: "finance", title: "GEO for Finance", short: "Build the trust AI requires to recommend financial services.", icon: "Landmark", keyword: "AI SEO for Finance" },
  { slug: "hospitality", title: "GEO for Hospitality", short: "Win AI recommendations for hotels, resorts and venues.", icon: "Hotel", keyword: "GEO for Hotels" },
  { slug: "automotive", title: "GEO for Automotive", short: "Be the brand AI recommends across the buyer journey.", icon: "Car", keyword: "GEO for Automotive" },
  { slug: "professional-services", title: "GEO for Professional Services", short: "Get cited when clients research firms and advisors via AI.", icon: "Briefcase", keyword: "GEO for Law Firms" },
  { slug: "enterprise", title: "Enterprise GEO", short: "Scaled GEO programs for complex, multi-brand enterprises.", icon: "Building", keyword: "Enterprise GEO" },
];

export const FEATURED_INDUSTRIES = INDUSTRIES.filter((i) => i.featured);
export const getIndustry = (slug) => INDUSTRIES.find((i) => i.slug === slug);
